export { default } from './Input';



// WEBPACK FOOTER //
// ./src/components/atoms/Input/index.js